var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ID",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.615,
    height: 17.663,
    viewBox: "0 0 24.615 17.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M22.349,72.3H2.266A2.265,2.265,0,0,0,0,74.566V87.7a2.265,2.265,0,0,0,2.266,2.266H22.349A2.265,2.265,0,0,0,24.615,87.7V74.566A2.265,2.265,0,0,0,22.349,72.3Zm.824,15.4a.824.824,0,0,1-.824.824H2.266a.824.824,0,0,1-.824-.824V74.566a.824.824,0,0,1,.824-.824H22.349a.824.824,0,0,1,.824.824Z",
    transform: "translate(0 -72.3)",
    fill: "#1077bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M86.122,205.25a2.652,2.652,0,1,0-3.956,0,3.812,3.812,0,0,0-1.833,3.256.721.721,0,0,0,.721.721h6.179a.721.721,0,0,0,.721-.721,3.812,3.812,0,0,0-1.833-3.256Zm-1.978-2.975a1.21,1.21,0,1,1-1.21,1.21A1.211,1.211,0,0,1,84.144,202.275Zm-2.256,5.51a2.369,2.369,0,0,1,4.513,0Z",
    transform: "translate(-76.471 -194.654)",
    fill: "#1077bb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M295.328,216.9h-5.407a.721.721,0,1,0,0,1.442h5.407a.721.721,0,0,0,0-1.442Z",
    transform: "translate(-275.297 -209.948)",
    fill: "#1077bb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M96.5,136.566H81.054a.721.721,0,1,0,0,1.442H96.5a.721.721,0,1,0,0-1.442Z",
    transform: "translate(-76.471 -133.476)",
    fill: "#1077bb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M295.328,281.167h-5.407a.721.721,0,1,0,0,1.442h5.407a.721.721,0,0,0,0-1.442Z",
    transform: "translate(-275.297 -271.125)",
    fill: "#1077bb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M293.783,345.434h-3.862a.721.721,0,1,0,0,1.442h3.862a.721.721,0,1,0,0-1.442Z",
    transform: "translate(-275.297 -332.302)",
    fill: "#1077bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.1e2e0f84687f4267ee77eef6c13b04bf.svg";
export { ForwardRef as ReactComponent };